function init() {
    let toggleEl = document.querySelectorAll(".accordion-heading");
    if (toggleEl) {
        toggleEl.forEach(element => {
            element.addEventListener("click", function(e) {
                let accordionBody = element.parentElement;
                e.preventDefault();
                if (accordionBody.classList.contains("closeBody")) {
                    accordionBody.classList.remove("closeBody");
                    accordionBody.classList.add("openBody");
                } else if (accordionBody.classList.contains("openBody")) {
                    accordionBody.classList.remove("openBody");
                    accordionBody.classList.add("closeBody");
                }
            });
        });
    }
}

export default { init };
